import { Flex } from 'antd';
import { rgba } from 'emotion-rgba';

import styled from '@emotion/styled';

export const Container = styled(Flex)`
  padding-bottom: 76px;
`;

export const ToolbarActions = styled(Flex)`
  height: 76px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 21px 0 ${({ theme }) => rgba(theme.colors.black, 0.14)};
  border-top: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  padding: 0 32px;
  position: fixed;
  left: 105px;
  right: 0;
  bottom: 0;
  z-index: 1;
`;

export const KYCActions = styled(Flex)`
  margin-top: 24px;
`;
